import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";


function DeleteEmployeeDialog({
  open,
  onClose,
  onConfirm,
  employee,
  isDeleting = false,
  deleteRelated = false,
  onToggleDeleteRelated,
}) {


  return (

    <Dialog

      open={open}

      onClose={onClose}

      disableEscapeKeyDown={isDeleting}

      maxWidth="xs"

      fullWidth

    >


      <DialogTitle>

        Delete Employee

      </DialogTitle>



      <DialogContent>


        <DialogContentText>

          Are you sure you want to delete this employee?

          <br />

          <br />

          <strong>
            {employee?.employee_name}
          </strong>

          <br />

          This action cannot be undone.

        </DialogContentText>

        <FormControlLabel
          sx={{ mt: 1 }}
          control={(
            <Checkbox
              checked={deleteRelated}
              onChange={(event) => onToggleDeleteRelated?.(event.target.checked)}
              disabled={isDeleting}
            />
          )}
          label="Delete all related records"
        />


      </DialogContent>



      <DialogActions>


        <Button

          variant="outlined"

          onClick={onClose}

          disabled={isDeleting}

        >

          Cancel

        </Button>



        <Button

          variant="contained"

          color="error"

          onClick={onConfirm}

          disabled={isDeleting}

          startIcon={
            isDeleting
            ? <CircularProgress size={16} color="inherit" />
            : null
          }

        >

          {
            isDeleting
            ? "Deleting..."
            : "Delete"
          }

        </Button>


      </DialogActions>


    </Dialog>

  );

}


export default DeleteEmployeeDialog;